import React from "react";
import { FaPhoneAlt, FaEnvelope, FaLinkedin, FaGithub } from "react-icons/fa";

function Contact() {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert(`Copied ${text} to clipboard!`);
  };

  return (
    <section id="contact" className="bg-gradient-to-b from-black via-black-200 to-indigo-900  text-slate-200 py-40 ">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold mb-4">Contact</h2>
          <div className=" flex justify-center items-center">
             <form
            action="https://getform.io/f/64d0b5ef-5af0-4aac-aea7-7da440dca34f"
            method="POST"
            className=" flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className="p-2 bg-transparent border-2 rounded-md text-sky-900 focus:outline-none border-cyan-900"
            />
            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              className="my-4 p-2 bg-transparent border-2 rounded-md text-sky-900 focus:outline-none border-cyan-900"
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              className="p-2 bg-transparent border-2 rounded-md text-sky-900 focus:outline-none border-cyan-900"
            ></textarea>
            

            <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
              Let's talk
            </button>
            
          </form>
        </div>
          <p className="text-gray-400 text-base">
            Feel free to reach out to me using any of the following methods.
          </p>
        </div>
        <div className="flex flex-wrap justify-center">
          <div className="mx-4 my-2">
            <button onClick={() => handleCopy("+91-9691531589")} className="shadow-gray-400 rounded-lg  shadow-md hover:scale-105 duration-500 py-2 px-2 flex justify-center items-center ">
              <FaPhoneAlt className="mr-2" />
              Phone: +91-9691531589
            </button>
          </div>
          <div className="mx-4 my-2">
            <button onClick={() => handleCopy("martina.varghese024@gmail.com")} className="shadow-gray-400 rounded-lg  shadow-md hover:scale-105 duration-500 py-2 px-2 flex justify-center items-center">
              <FaEnvelope className="mr-2" />
              martina.varghese024@gmail.com
            </button>
          </div>
          <div className="mx-4 my-2">
            <a href="https://www.linkedin.com/in/martinavarghese/" target="_blank" rel="noopener noreferrer" className="shadow-gray-400 rounded-lg shadow-md hover:scale-105 duration-500 py-2 px-2 flex justify-center items-center">
              <FaLinkedin className="mr-2" />
              LinkedIn
            </a>
          </div>
          <div className="mx-4 my-2">
            <a href="https://github.com/martina024" target="_blank" rel="noopener noreferrer" className="shadow-gray-400 rounded-lg  shadow-md hover:scale-105 duration-500 py-2 px-2 flex justify-center items-center ">
              <FaGithub className="mr-2" />
              GitHub
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

























// import React from "react";
// import {BsFillTelephoneFill } from "react-icons/bs";

// const Contact = () => {
//   return (
//     <div
//       name="contact"
//       className="w-full h-screen  bg-gradient-to-b from-purple-300 to-bg-transparent p-4 text-sky-900"
//     >
//       <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
//         <div className="pb-8 pt-20 md:mt-[0rem] sm:mt-[30rem]">
//           <p className="text-4xl font-bold inline border-b-4 border-gray-500">
//             Contact 
//           </p>
//          <div className="p-2 bg-transparent border-1 rounded-md text-sky-900 focus:outline-none border-cyan-900" style={{display:"flex", fontSize:"large" , marginTop:"20px",border:"0px solid blue",width:"20rem" }}>
//          <p className="py-6"><BsFillTelephoneFill  size={35}/></p>
//          <span style={{fontWeight:"bold" ,fontSize:"25px",color:"brown", textAlign:"center" }}>9691531589</span>
//          </div>
//         <p>Submit the form below to get in touch with me</p>
//         </div>

//         <div className=" flex justify-center items-center">
//           <form
//             action="https://getform.io/f/64d0b5ef-5af0-4aac-aea7-7da440dca34f"
//             method="POST"
//             className=" flex flex-col w-full md:w-1/2"
//           >
//             <input
//               type="text"
//               name="name"
//               placeholder="Enter your name"
//               className="p-2 bg-transparent border-2 rounded-md text-sky-900 focus:outline-none border-cyan-900"
//             />
//             <input
//               type="text"
//               name="email"
//               placeholder="Enter your email"
//               className="my-4 p-2 bg-transparent border-2 rounded-md text-sky-900 focus:outline-none border-cyan-900"
//             />
//             <textarea
//               name="message"
//               placeholder="Enter your message"
//               rows="10"
//               className="p-2 bg-transparent border-2 rounded-md text-sky-900 focus:outline-none border-cyan-900"
//             ></textarea>
            

//             <button className="text-white bg-gradient-to-b from-teal-700 to-blue-800 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
//               Let's talk
//             </button>
            
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;